module.exports = __webpack_public_path__ + "static/media/event-brikk-preview.83951201.png";